import { useQuery } from "react-query";
import { useClient } from "../hooks";

export const useUserQuery = (config) => {
  const client = useClient();

  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await client.get("me").get("data");
      } catch (ex) {
        const status = ex.response?.status;

        if (status === 401 || status === 403) {
          return null;
        } else {
          throw ex;
        }
      }
    },
    ...config,
  });
};
